export interface MapProps {}

export const useMap = (props: MapProps) => {
  return {
    ...props,
  }
}
